import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupRoutes = {
  name: 'setup',
  path: 'setup',
  component: () => import('./Setup.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
